<template>
  <!--Chat Modal-->
  <div class="chat-modal">
    <button
      type="button"
      class="btn chat-icon"
      data-bs-toggle="modal"
      data-bs-target="#staticBackdrop"
    >
      <img src="@/assets/img/header/left-menu/chat.png" alt="chat-img" />
    </button>
    <div
      class="modal fade"
      id="staticBackdrop"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="right-site-menu">
              <div class="right-box">
                <ul class="chat-wrapper reverse-list main-chat-wrap w-100" ref="chatListModal">
                  <li v-for="(blocks, date) in messages" :key="date" class="items">
                    <!-- Date Divider -->
                    <div class="date-divider d-flex align-items-center justify-content-between">
                      <span class="date">{{ date }}</span>
                      <span class="date-line"></span>
                    </div>
                    <!-- Message Blocks -->
                    <ul>
                      <li v-for="block in blocks" :key="block.client_id" class="items">
                        <div class="thumb-divider d-flex align-items-center">
                          <div class="man">
                            <img 
                              v-lazy="block.messages[0].client.photo || defaultImage" 
                              alt="man-img" 
                              style="border-radius: 8px;"
                            />
                          </div>
                          <span class="name">{{ block.messages[0].client.display_name }}</span>
                        </div>
                        <div class="right-content reverse-list">
                          <div v-for="message in block.messages" :key="message.id" class="box">
                            <span class="bg-3 message-item">{{ message.message }}</span>
                            <span class="box-date">{{ message.created_at_time }}</span>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
                <ul class="main-chat-codding" v-if="isLoggedIn">
                  <li class="items">
                    <form @submit.prevent="onSendMessage">
                      <input type="text" :placeholder="$t('Your Message')" v-model="message" />
                      <button class="telegram" type="submit">
                        <img
                          src="@/assets/img/header/right-chat/tele.png"
                          alt="tele-img"
                        />
                      </button>
                    </form>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--Chat Modal-->

  <!--Right Box Chat-->
  <div class="right-site-menu">
    <div class="right-box">
      <ul class="chat-wrapper reverse-list main-chat-wrap w-100" ref="chatList">
        <li v-for="(blocks, date) in messages" :key="date" class="items">
          <span
            class="date-divider d-flex align-items-center justify-content-between"
          >
            <span class="date">{{ date }}</span>
            <span class="date-line"></span>
          </span>

          <!-- Iterate over blocks for each client under the same date -->
          <div v-for="block in blocks" :key="block.client_id" class="items">
            <!-- Client's message block -->
            <span
              class="thumb-divider d-flex align-items-center mb-0"
            >
              <div class="man">
                <img
                  v-lazy="
                    block.messages[0].client.photo ||
                    '@/assets/img/header/right-chat/man.png'
                  "
                  alt="man-img"
                  style="border-radius: 8px;"
                />
              </div>
              <span class="name">{{ block.messages[0].client.display_name }}</span>
            </span>

            <!-- Displaying messages for this block -->
            <div class="right-content reverse-list">
              <div
                v-for="message in block.messages"
                :key="message.id"
                class="box mb-1"
              >
                <span class="bg-3 mb-0 message-item">{{ message.message }}</span>
                <span class="box-date" style="font-size: 10px;">{{ message.created_at_time }}</span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <ul class="main-chat-codding" v-if="isLoggedIn">
        <li class="items">
          <form @submit.prevent="onSendMessage">
            <input type="text" :placeholder="$t('Your Message')"
            v-model="message" />
            <button class="telegram" type="submit">
              <img
                src="@/assets/img/header/right-chat/tele.png"
                alt="tele-img"
              />
            </button>
          </form>
        </li>
      </ul>
    </div>
  </div>
  <!--Right Box Chat-->
</template>

<script>
import { useGamesStore } from "@/store/games";
import { mapState, mapActions } from "pinia";
import helpers from "@/helpers";
import { useAuthStore } from "@/store/auth";

export default {
  name: "ChatComponent",
  computed: {
    ...mapState(useGamesStore, ["messages"]),
    ...mapState(useAuthStore, ["isLoggedIn"]),
  },
  data() {
    return {
      message: "",
    };
  },
  methods: {
    ...mapActions(useGamesStore, ["fetchMessages", "postMessage"]),
    scrollToBottom() {
      const chatList = this.$refs.chatList;
      if(chatList){
        chatList.scrollTop = chatList.scrollHeight;
      }

      const chatListModal = this.$refs.chatListModal;
      if(chatListModal){
        chatListModal.scrollTop = chatListModal.scrollHeight;
      }
    },
    async onSendMessage() {
      const result = this.postMessage(this.message, null);
      if(result) {
        this.message = "";
      } else {
        helpers.showToast(this.$t("Failed to send message"), this.$t("Internal Error"), "error");
      }
    },
  },
  async mounted() {
    await this.fetchMessages();

    this.scrollToBottom();
  },
  watch: {
    messages() {
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
  },
};
</script>

<style scoped>

.reverse-list {
  display: flex;
  flex-direction: column-reverse;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.message-item {
  overflow-wrap: break-word;
}

</style>
